import React from 'react';
import { ActiveTestProvider } from '@lifeomic/phc-ui-omics-explorer/src/ActiveTestContext';
import { ActiveVariantTypeProvider } from '@lifeomic/phc-ui-omics-explorer/src/ActiveVariantTypeContext';
import { DefaultFiltersProvider } from '@lifeomic/phc-ui-omics-explorer/src/DefaultFiltersContext';
import { OmicsExplorer } from '@lifeomic/phc-ui-omics-explorer/src/OmicsExplorer';
import { SavedFiltersProvider } from '@lifeomic/phc-ui-omics-explorer/src/SavedFiltersContext';
import { SelectedFilterOptionsProvider } from '../../../common/Genomics/SelectedFilterOptionsContext';
import { SelectedFilterProvider } from '@lifeomic/phc-ui-omics-explorer/src/SelectedFilterContext';
import { SelectedSequenceTypeProvider } from '@lifeomic/phc-ui-omics-explorer/src/SequenceTypeContext';
import MemberDetail from './index';

type OmicsExplorerContentProps = {
  memberId: string;
};

export const OmicsExplorerContent: React.FC<OmicsExplorerContentProps> = ({
  memberId,
}) => {
  return (
    <ActiveTestProvider>
      <SelectedSequenceTypeProvider>
        <ActiveVariantTypeProvider>
          <SelectedFilterProvider>
            <SelectedFilterOptionsProvider>
              <SavedFiltersProvider>
                <DefaultFiltersProvider>
                  <OmicsExplorer subjectId={memberId} />
                </DefaultFiltersProvider>
              </SavedFiltersProvider>
            </SelectedFilterOptionsProvider>
          </SelectedFilterProvider>
        </ActiveVariantTypeProvider>
      </SelectedSequenceTypeProvider>
    </ActiveTestProvider>
  );
};

const MemberOmicsExplorer: React.FC = () => {
  return <MemberDetail section="omics-explorer" />;
};

MemberOmicsExplorer.displayName = 'MemberOmicsExplorer';
export default MemberOmicsExplorer;
